import 'SCSS/main.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';

import { config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

const sitePrefix = process.env.PREFIX || '';

const App = ({ Component, pageProps }) => {
  const { locale } = pageProps;
  return (
    <div className={locale === 'ja' ? 'japanese' : ''}>
      <Component
        {...pageProps}
        sitePrefix={sitePrefix}
      />
    </div>
  );
};

export default App;
